import * as React from "react";
import { forwardRef } from "react";
const SvgPromotions = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M10.4451 4.63461C11.309 3.78846 12.691 3.78846 13.5549 4.63461L13.9808 5.05176C14.3904 5.45296 14.9392 5.6803 15.5125 5.68625L16.1087 5.69243C17.3179 5.70498 18.295 6.68215 18.3076 7.89133L18.3138 8.48745C18.3197 9.06079 18.547 9.60963 18.9482 10.0192L19.3654 10.4451C20.2115 11.309 20.2115 12.691 19.3654 13.5549L18.9482 13.9808C18.547 14.3904 18.3197 14.9392 18.3138 15.5125L18.3076 16.1087C18.295 17.3179 17.3179 18.295 16.1087 18.3076L15.5125 18.3138C14.9392 18.3197 14.3904 18.547 13.9808 18.9482L13.5549 19.3654C12.691 20.2115 11.309 20.2115 10.4451 19.3654L10.0192 18.9482C9.60963 18.547 9.06079 18.3197 8.48745 18.3138L7.89133 18.3076C6.68215 18.295 5.70498 17.3179 5.69243 16.1087L5.68625 15.5125C5.6803 14.9392 5.45296 14.3904 5.05176 13.9808L4.63461 13.5549C3.78846 12.691 3.78846 11.309 4.63461 10.4451L5.05176 10.0192C5.45296 9.60963 5.6803 9.06079 5.68625 8.48745L5.69243 7.89133C5.70498 6.68215 6.68215 5.70498 7.89133 5.69243L8.48745 5.68625C9.06079 5.6803 9.60963 5.45296 10.0192 5.05176L10.4451 4.63461Z",
	stroke: "currentColor",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M14 15C14.5523 15 15 14.5523 15 14C15 13.4477 14.5523 13 14 13C13.4477 13 13 13.4477 13 14C13 14.5523 13.4477 15 14 15Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M10 11C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9 15L15 9",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}));
const ForwardRef = forwardRef(SvgPromotions);
export default ForwardRef;
